export enum ClientDetailsDeedTypeEnum {
  Cooperation = 'Cooperation',
  CooperationPledging = 'CooperationPledging',
  Divorce = 'Divorce',
  DivorceMortgage = 'DivorceMortgage',
  DivorcePrivate = 'DivorcePrivate',
  Encompassing = 'Encompassing',
  External = 'External',
  Mortgage = 'Mortgage',
  Private = 'Private',
  ResidSociety = 'ResidSociety',
  ResidSocietyMember = 'ResidSocietyMember',
  Unknown = 'Unknown',
}
